import React__default from 'react';
import PropTypes from 'prop-types';
import VerticalSeparator from '../VerticalSeparator/VerticalSeparator.js';

var propTypes = {
  /** Use flagBlock to depict Country flag based on link selection. */
  flagBlock: PropTypes.node.isRequired,
  /** link allows control to select a country */
  link: PropTypes.node.isRequired,
  /** children allows any JSX content into the component and provides more structure */
  children: PropTypes.node
};
function CountrySelector(_ref) {
  var children = _ref.children,
    flagBlock = _ref.flagBlock,
    link = _ref.link;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "country-selector",
    "data-testid": "country-selector"
  }, /*#__PURE__*/React__default.createElement(VerticalSeparator, null, flagBlock, link), children);
}
CountrySelector.propTypes = propTypes;

export { CountrySelector as default };
//# sourceMappingURL=CountrySelector.js.map
